<template>
    <div ref="circle" class="circle-detail rounded-full bg-purple-dark absolute pin m-auto z-0 flex items-center justify-center">
        <span class="font-bold tracking-wide leading-tight">
            <slot />
        </span>
    </div>
</template>

<script>
import anime from 'animejs';

export default {
    props: {
        animated: {
            default: false,
            type: Boolean
        },
        yAxis: {
            type: Number,
            default: 0,
        },
        xAxis: {
            type: Number,
            default: 0,
        },
        delay: {
            type: Number,
            default: 0
        }
    },
    watch: {
        animated(newVal) {
            if(newVal) {
                anime({
                    targets: this.$refs.circle,
                    translateY: this.yAxis,
                    translateX: this.xAxis,
                    delay: this.delay,
                    easing: 'easeOutQuint',
                    duration: 600,
                })
            }
        }
    }
}
</script>
